export default {"src":"/_next/static/image/public/images/flags/flag_46.4f633455b83d6d4b4ee98b74d56ea99f.svg","height":16,"width":24};